module.exports = __webpack_public_path__ + "static/media/8OLA30.5251a3e2.jpg";